import React from "react";
import { Grid, IconButton } from "@material-ui/core";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import classes from './index.module.scss';

const Pagination = ({ increasePage, decreasePage, pageSize, currentPage, pageCount, itemsCount }) => {
  const start = currentPage * pageSize;
  const end = Math.min(start + pageSize, itemsCount);

  return (
    <Grid container justifyContent="center" alignItems="center" className={classes.pagination} spacing={2}>
      <Grid item>
        <IconButton
          aria-label='previous page'
          color='secondary'
          size='small'
          disabled={currentPage === 0}
          onClick={decreasePage}
        >
          <ArrowBackIosIcon />
        </IconButton>
      </Grid>
      <Grid item>Showing {start} - {end}</Grid>
      <Grid item>
        <IconButton
          aria-label='next page'
          color='secondary'
          size='small'
          disabled={currentPage === pageCount - 1}
          onClick={increasePage}
        >
          <ArrowForwardIosIcon />
        </IconButton>
      </Grid>
    </Grid>
  )
}

export default Pagination;